import { render, staticRenderFns } from "./CreateKlaimCCPd.vue?vue&type=template&id=a41b4d48&scoped=true&"
import script from "./CreateKlaimCCPd.vue?vue&type=script&lang=js&"
export * from "./CreateKlaimCCPd.vue?vue&type=script&lang=js&"
import style0 from "./CreateKlaimCCPd.vue?vue&type=style&index=0&id=a41b4d48&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a41b4d48",
  null
  
)

export default component.exports